// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.floorplans.photos.RentalManagerUserPropertyFloorPlanPhotoV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  UserPropertyFloorPlanPhotoCaptionV2RequestDto,
  UserPropertyFloorPlanPhotoDeleteV2RequestDto,
} from '../..';

export const RentalManagerUserPropertyFloorPlanPhotoV2WebApiHandler_caption_Path =
  '/api/web/v2/users/properties/floorPlans/photos/caption';

/**
 * Update caption of a floor plan photo
 */
export const RentalManagerUserPropertyFloorPlanPhotoV2WebApiHandler_caption = (
  postData: UserPropertyFloorPlanPhotoCaptionV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyFloorPlanPhotoCaptionV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyFloorPlanPhotoV2WebApiHandler_caption_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyFloorPlanPhotoV2WebApiHandler_delete_Path =
  '/api/web/v2/users/properties/floorPlans/photos/delete';

/**
 * Delete a photo of a floor plan
 */
export const RentalManagerUserPropertyFloorPlanPhotoV2WebApiHandler_delete = (
  postData: UserPropertyFloorPlanPhotoDeleteV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyFloorPlanPhotoDeleteV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyFloorPlanPhotoV2WebApiHandler_delete_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
